<template>
  <div id="event-details">
    <div class="flex items-center pb-4 mb-4 border-b">
      <i class="i i-map-1 text-3xl block h-[28px]" />
      <h6 class="pl-2 font-semibold">
        {{ $t('word.event_info') }}
      </h6>
    </div>
    <ul class="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <li
        v-for="event in packageItem.events"
        :id="`event-details-${event.id}`"
        :key="event.id"
      >
        <div class="relative">
          <google-map-wrapper
            :latitude="event.venue.location.latitude"
            :longitude="event.venue.location.longitude"
          />
          <div class="absolute top-0 right-0 p-2 m-2 bg-white rounded-lg drop-shadow-2xl lg:drop-shadow-none">
            <h5 class="text-sm font-bold">
              {{ event.venue.name }}
            </h5>
            <h6 class="text-xs">
              {{ event.venue.address }}, {{ event.venue.address }}
            </h6>
            <div class="border-t text-[10px] mt-1 font-bold">
              <h6>{{ $d($dayjs(event.eventDateTime).format(), 'full') }}</h6>
            </div>
          </div>
          <div class="pr-6 relative mt-[-30px]">
            <div class="relative py-4 bg-white rounded-lg rounded-tl-none drop-shadow-2xl lg:drop-shadow-none">
              <ul v-if="event.homeClub && event.guestClub" class="flex flex-col gap-y-2 px-4 border-l-4 border-primary">
                <li>
                  <NuxtLink
                    class="flex items-center"
                    :to="
                      $localePath({
                        name: 'football-trips-slug',
                        params: { slug: `${event.homeClub.slug}` },
                      })
                    "
                  >
                    <img :src="event.homeClub.logo.originalUrl" :alt="event.homeClub.name" class="w-5 h-5">
                    <h6 class="pl-2 text-sm capitalize">
                      {{ event.homeClub.name }}
                    </h6>
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                    class="flex items-center"
                    :to="
                      localePath({
                        name: 'football-trips-slug',
                        params: { slug: `${event.guestClub.slug}` },
                      })
                    "
                  >
                    <img :src="event.guestClub.logo.originalUrl" :alt="event.guestClub.name" class="w-5 h-5">
                    <h6 class="pl-2 text-sm capitalize">
                      {{ event.guestClub.name }}
                    </h6>
                  </NuxtLink>
                </li>
              </ul>
              <div v-else class="gap-y-2 px-4 border-l-4 border-primary">
                <h6>{{ event.title }}</h6>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { ComputedRef } from '#imports'

interface MapStyle {
  featureType: string
  elementType?: string
  stylers: Array<{
    visibility: string
  }>
}

const mapStyles: MapStyle[] = [
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
]

// Store composables
const packageStore = usePackageStore()

// Computed properties
const packageItem = computed(() => packageStore.package)

// Composables
const localePath = useLocalePath()
</script>
